module.exports = __webpack_public_path__ + "static/img/landing.df991dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing.jpg
// module id = jwdm
// module chunks = 1